import React, { useState, useEffect } from 'react'
import { MainNav } from '../components/shared/MainNav'
//import logo from '../logo.png'
import { useLocation } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Message } from '../components/shared/Message';
import { LinkButton } from '../components/shared/LinkButton'
import { Breadcrumbs } from '../components/shared/Breadcrumbs';
import { ErrorFallback } from '../components/shared/ErrorFallback';
import * as Sentry from '@sentry/react';
import { Footer } from '../components/shared/Footer';
import { AdContainer } from '../components/shared/AdContainer';

export const Layout = (props) => {

    const [isMenuToggled, setIsMenuToggled] = useState(false);

    const handleMenuToggle = (val) => {
        setIsMenuToggled(val)
    }

    const location = useLocation();

    useEffect(() => {
        props.showMessage("")
    }, [location]);

    const handleOnError = (error, errorInfo) => {
        console.error('Error caught by ErrorBoundary:', error, errorInfo);
        // <div className="topnav-separator"></div>

    };



    return (

        <>
            <header className="page-header">
                <MainNav handleMenuToggle={handleMenuToggle} isMenuToggled={isMenuToggled} />
            </header>
            <main className="page-body">
                <Breadcrumbs isMenuToggled={isMenuToggled} />
                {/* <AdContainer />*/}
                <Sentry.ErrorBoundary key={location.pathname} fallback={<ErrorFallback />} onError={handleOnError}>
                    {props.children}
                </Sentry.ErrorBoundary>
                {/*<AdContainer />*/}
                <Message {...props}></Message>
            </main>
            <footer className="page-footer">
                <Footer />
            </footer>
        </>



    )
}
